<template>
    <div>

        <TextBanner>
       <p> Das bisher letzte Modul dockte im Juli 2021 an der ISS an. Das russische <b>Forschungsmodul Nauka</b>. An ihm befestigt: ein <b>europäischer Roboterarm</b>.</p>
       <p>Technisch gesehen könnte die ISS <b>bis 2028 im Einsatz</b> sein. Russland macht aber Andeutungen, die Kooperation vorher zu beenden. </p>
        </TextBanner>

        <InfoBox modalName="ERA">
            <template #title>Der europäische Roboterarm (ERA)</template>
            <template #subline></template>


                <p>Seit Sommer 2021 ist der elf Meter lange Roboterarm der Esa an der ISS. Das Besondere: Er kann sich mit beiden Enden verankern oder greifen und bietet damit mehr Flexibilität für die Wissenschaftler*innen. Der Arm kann sich so quasi herumhangeln.</p>
                                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/060_schema.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="600" data-height="600" v-lazy="require('../assets/img/060_schema_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; Esa/D. Ducros</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Der Roboterarm ERA kann Teile mit bis zu 8.000 Kilogramm Gewicht transportieren und mit einer Genauigkeit von fünf Millimetern an einem gewünschten Ort absetzen. Astronauten können ebenfalls an ihren Einsatzort gebracht werden. Mithilfe der vier Infrarotkameras kann auch die Außenhülle der ISS überwacht werden.</p>
                <p></p>
                                <!-- FullscreenImage, lazyload -->
                <FullscreenImage :src="require('../assets/img/060_halle.jpg')">
                    <figure>
                        <div class="lazy-container bg-dark">
                            <span class="zdf-load-icon"></span>
                            <!-- required (ratio): data-width, data-height -->
                            <img class="img-fluid" data-width="700" data-height="589" v-lazy="require('../assets/img/060_halle_thumb.jpg')" alt="">
                        </div>
                        <figcaption>
                            <div class="legal">&copy; RSC Energia</div>
                        </figcaption>
                    </figure>
                </FullscreenImage>

                <p>Anders als die beiden schon existierenden Roboterarme der Station versorgt ERA vor allem den russischen Teil der ISS.</p>
                <p></p>

        </InfoBox>

        <!-- Fallback -->
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/fallback_070_p.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/fallback_070_l.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/fallback.jpg" alt="">
            </picture>
            <div class="hotspot hotspot--links" v-on:click="infobox('ERA')"></div>


        </Fallback>


    </div>
</template>

<script>
    export default {
        name: 'infobox',
        babylonState: {
            camera: {
                position: [.6,2,10],   //[1.56,0.1,30],
                target: [.5,-4.2,-3.8],       //[.5,0,0]
                useAutoRotationBehavior: true,
                idleRotationSpeed: 0.01,
            },
            
            
            iss: {

                SpaceX_Body: {
                    visible: true,
                    pickable: false,
                    // overlayColor: [20/255, 192/255, 216/255],
                    // overlayAlpha: 0.6,
                    SpaceX_Cargo: {
                        visible: true,
                        pickable: false,
                        // overlayColor: [20/255, 192/255, 216/255],
                        // overlayAlpha: 0.6,
                    },
                    SpaceX_Klappe: {
                        visible: true,
                        pickable: false,
                        // overlayColor: [20/255, 192/255, 216/255],
                        // overlayAlpha: 0.6,
                    }
                },

                Nauka: {

                    overlayColor: [220/255, 52/255, 109/255],
                    overlayAlpha: 0.6,
                
                    Panels_Nauka_solar:{
                            overlayColor: [220/255, 52/255, 109/255],
                            overlayAlpha: 0.6,
                    },

                    ERA_Roboterarm: {
                      overlayColor: [20/255, 192/255, 216/255],
                        overlayAlpha: .8,
                    }
                },

            },

        hotspots: {
            ERA: {
                visible: true,
                position: [.7, -4.1, -2.7],
                renderingGroupId: 0,
                scale: 1,
                // InfoBox öffnen
                infoBox: 'ERA'
            },
        },     
    },
        babylonReady: function () {

        //this.$babylonController.goToAnimation("spacex_anim", 100);
        this.$babylonController.timer.add(1400, () => {
            this.$babylonController.setCameraRadiusLimit(7,200);
        });

        //this.$audioController.initTrack('speaker', require('./../assets/audio/2496003_Starhorizon_192.mp3'), true, false);


        },
    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {

        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);
        }
    }


</style>
